import React from 'react';
import {withStyles} from "@material-ui/core";
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';

const CabinetAccordion = ({isSick, ...props}) => {

    const Accordion = withStyles({
        root: {
            margin: '10px 0px',
            boxShadow: 'none',
            transition: '0.5s',
            height: '70px',
            '&:not(:last-child)': {
                borderBottom: 0,
            },
            '&:before': {
                display: 'none',
            },
            '@media(max-width: 900px)': {
                height: 'max-content'
            }
        },
        expanded: {
            boxShadow: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px',
            height: 'min-content',
            margin: '10px 0px !important',
        },
    })(MuiAccordion);

    return (<Accordion {...props}/>)
}

const CabinetAccordionSummary = ({isSick, ...props}) => {
    const AccordionSummary = withStyles({
        root: {
            backgroundColor: isSick ? '#FFEAEA' : '#F7F8F9',
            marginBottom: -1,
            height: '70px',
            borderRadius: '5px',
            '&$expanded': {
                minHeight: 56,
            },
            '@media(max-width: 900px)': {
                height: 'max-content'
            }
        },
        content: {
            alignItems: "center",
            '@media(max-width: 900px)': {
                alignItems: 'flex-start'
            },
            '&$expanded': {
                margin: '12px 0',
            },
        },
        expanded: {
            borderRadius: '5px 5px 0px 0px',
            backgroundColor: isSick ? '#FFEAEA' : '#EAFFFD',
        },
        expandIcon: {
            backgroundColor: 'transparent',
            '@media(max-width: 900px)': {
                position: 'absolute',
                bottom: 0,
                right: 15
            }
        }
    })(MuiAccordionSummary);

    return (<AccordionSummary {...props} />)
}

const CabinetAccordionDetails = ({...props}) => {

    const AccordionDetails = withStyles((theme) => ({
        root: {
            backgroundColor: 'white',
            flexDirection: 'column',
            padding: theme.spacing(2),
            borderRadius: '0px 0px 5px 5px',
        },
    }))(MuiAccordionDetails);

    return (<AccordionDetails {...props} />)

}

export {
    CabinetAccordion,
    CabinetAccordionSummary,
    CabinetAccordionDetails
}